import { useQuery } from '@tanstack/react-query';

import { homeContentService } from '@project/services';
import { HomeCharityOutreachesModel, HomeContentsModel } from './home-content.model';

export const useGetHomeContentQuery = () =>
  useQuery(['getHomeContent'], () => homeContentService.getHomeContents(), {
    select: HomeContentsModel,
  });

export const useGetHomeCharityOutreachesQuery = () =>
  useQuery(['getHomeCharityOutreaches'], () => homeContentService.getHomeCharityOutreaches(), {
    select: HomeCharityOutreachesModel,
  });
